module.exports = __webpack_public_path__ + "media/images/lp_reason-4-488c062f09de9d4b8b1cd60d076a92d9.webp";